<template>
    <div class="client profile">
        <vs-tabs alignment="left" position="top" class="extended">
            <vs-tab icon="account_circle" label="Membresía">
                <div>
                    <div class="editar" v-if="userInfoData.role == Roles.Admin">
                        <router-link to="/admin/memberships"><feather type="arrow-left"/>Regresar</router-link>
                    </div>
                    <div class="picture">
                        <vs-avatar :src="profileImg" size="120px"/>
                        <div class="info">
                            <p>{{ customer.firstName + ' ' + customer.lastName }}</p>
                            <span>{{ customer.email }}</span>
                            <div class="client-status">
                                <div :class="['circle', customer.statuscode === 0 ? 'danger' : 'success' ]"></div>
                                {{customer.statusname | capitalize}}
                            </div>
                        </div>
                    </div>
                    <div class="wrap-detail-account">
                        <div class="title"><h2>Detalle de la cuenta</h2></div>
                        <div class="detail">
                            <h3>Casillero: </h3>
                            <p>{{ customer.typename }}</p>
                        </div>
                        <div class="detail">
                            <h3>Fecha Ingreso: </h3>
                            <p>{{ customer.createdAt | moment("DD/MM/YYYY") }}</p>
                        </div>
                        <div class="detail">
                            <h3>Profesión: </h3>
                            <p>{{ customer.profession }}</p>
                        </div>
                        <div class="detail">
                            <h3>Cédula o pasaporte: </h3>
                            <p>{{ customer.identification }}</p>
                        </div>
                        <div class="detail">
                            <h3>Teléfono: </h3>
                            <p>{{ customer.mobile }} / {{ customer.phone }}</p>
                        </div>
                        <div class="detail">
                            <h3>Fecha Nacimiento: </h3>
                            <p>{{ customer.birthdate | moment("DD/MM/YYYY") }}</p>
                        </div>
                        <div class="detail" v-if="customer.typecode == '03'">
                            <h3>Cod Membresía: </h3>
                            <p> MS-{{ customer.id }}</p>
                        </div>
                    </div>
                    <div class="wrap-delivery">
                        <div class="title">
                            <h2>Información Geográfica</h2>
                        </div>
                        <div class="detail">
                            <h3>Provincia: </h3>
                            <p>{{ customer.pvname | capitalize }}</p>
                        </div>
                        <div class="detail">
                            <h3>Cantón: </h3>
                            <p>{{ customer.ctname | capitalize }}</p>
                        </div>
                        <div class="detail">
                            <h3>Distrito: </h3>
                            <p>{{ customer.dtname | capitalize }}</p>
                        </div>
                        <div class="address">
                            <h3>Dirección: </h3>
                            <p>{{ customer.address }}</p>
                        </div>
                        <div class="detail">
                            <h3>Entrega: </h3>
                            <p>{{ customer.dlvName }}</p>
                        </div>
                        <div class="detail">
                            <h3>Notificar: </h3>
                            <p>{{ notificationInfo() }}</p>
                        </div>
                    </div>
                </div>
            </vs-tab>
            <vs-tab icon="shopping_cart" label="Afiliados" v-if="userInfoData.role == Roles.Admin">
                <div class="" v-if="members.length > 0">
                    <vs-table :data="members" pagination max-items="50" search>
                        <template slot="thead">
                            <vs-th sort-key="firstName">Nombre</vs-th>
                            <vs-th sort-key="email">Email</vs-th>
                            <vs-th sort-key="phone">Teléfono</vs-th>
                            <vs-th sort-key="id" class="width-30"></vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].firstName">{{ `${data[indextr].firstName } ${data[indextr].lastName}`}}</vs-td>
                                <vs-td :data="data[indextr].email"> {{ data[indextr].email }}</vs-td>
                                <vs-td :data="data[indextr].phone"> {{ data[indextr].phone }}</vs-td>
                                <vs-td :data="data[indextr].id">
                                    <div class="table-actions">
                                        <router-link :to="`/admin/franchises/member/detail/${data[indextr].id}`"><feather type="eye"/></router-link>
                                    </div>
                                </vs-td>  
                            </vs-tr>
                        </template>
                    </vs-table>
                </div> 
                <displayInformation  v-if="members.length < 1" message="El cliente no tiene afiliados registrados" :showButton="false"></displayInformation>
            </vs-tab>
            <vs-tab icon="shopping_cart" label="CashBox" v-if="userInfoData.role == Roles.Admin">
                <div class="" v-if="cashbacks.length > 0">
                    <vs-table :data="cashbacks" pagination max-items="50" search>
                        <template slot="thead">
                            <vs-th sort-key="period">Periodo</vs-th>
                            <vs-th sort-key="month">Mes</vs-th>
                            <vs-th sort-key="begDate">Fecha Inicio</vs-th>
                            <vs-th sort-key="endDate">Fecha Cierre</vs-th>
                            <vs-th sort-key="totalPounds" class="center">Cant Libras</vs-th>
                            <vs-th sort-key="totalAmount" class="center">CashBox</vs-th>
                            <vs-th sort-key="statusName">Estado</vs-th>
                            <vs-th sort-key="id" class="width-30"></vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].period">{{data[indextr].period}}</vs-td>
                                <vs-td :data="data[indextr].month">{{ months[data[indextr].month - 1] }}</vs-td>
                                <vs-td :data="data[indextr].begDate"> {{ data[indextr].begDate | moment('DD/MM/YYYY')}}</vs-td>
                                <vs-td :data="data[indextr].endDate"> {{ data[indextr].endDate | moment('DD/MM/YYYY')}}</vs-td>
                                <vs-td :data="data[indextr].totalPounds" class="center"> {{ data[indextr].totalPounds }}</vs-td>
                                <vs-td :data="data[indextr].totalAmount" class="center"> ${{ data[indextr].totalAmount }}</vs-td>
                                <vs-td :data="data[indextr].statusName" :class="`pilled p-${data[indextr].st01Code}`"> 
                                    {{ data[indextr].totalPounds > 0 ? data[indextr].statusName : 'No Aplica'}}
                                </vs-td>
                                <vs-td :data="data[indextr].id">
                                    <div class="table-actions">
                                        <router-link :to="`/admin/cashback/detail/${data[indextr].id}`"><feather type="eye"/></router-link>
                                        <a href="javascript:void(0)" @click="openModal(data[indextr].id)" v-if="data[indextr].st01Code == 8 && data[indextr].totalAmount > 0"><feather type="credit-card"/></a>
                                        <!-- <a href="javascript:void(0)" @click="openModal(data[indextr].id)"><feather type="credit-card"/></a> -->
                                    </div>
                                </vs-td>                   
                            </vs-tr>
                        </template>
                    </vs-table>
                </div> 
                <displayInformation  v-if="cashbacks.length < 1" message="El cliente no tiene cashback genereados" :showButton="false"></displayInformation>
            </vs-tab>
        </vs-tabs>

        <modalBasic :show="ModalActive">
            <div class="modal-header" slot="modal-header">Detalle del pago</div>
            <div class="modal-body modal-member" slot="modal-body">
                <form>
                    <div :class="['form-input',{'has-error': $v.payment.txNumber.$error }]">
                        <vs-input label="Número Transacción" v-model.trim="$v.payment.txNumber.$model" @keypress="isNumber($event)"/>
                        <span class="error-text" v-if="$v.payment.txNumber.$error"><feather type="info" />Este campo es requerido</span>
                    </div>
                    <div :class="['form-input',{'has-error': $v.payment.bank.$error }]">
                        <!-- <vs-input label="Banco" v-model.trim="$v.payment.bank.$model"/> -->
                        <vs-select label="Banco" v-model="$v.payment.bank.$model">
                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in banks" />
                        </vs-select>
                        <span class="error-text" v-if="$v.payment.bank.$error"><feather type="info" />Este campo es requerido</span>
                    </div>
                    <div class="form-input">
                        <label for="file-input">Comprobante</label>
                        <input type="file" id="file" ref="file" accept="image/*" v-on:change="handleFileUpload()"/>
                    </div>
                </form>
            </div>
            <div class="modal-footer" slot="modal-footer">
                <vs-button color="danger" type="border" icon="block"  @click="closeModal()">Cancelar</vs-button>
                <vs-button :disabled="confirmStatus || $v.$invalid" id="btnConfirm" color="success" type="border" icon="check" 
                    @click="handleRequest" class="vs-con-loading__container"> Guardar</vs-button>
            </div>
        </modalBasic>

    </div>
</template>
<script>
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import { mapState, mapActions } from 'vuex'
import Customer from "@/models/ClientModel"
import CashbackModel from "@/models/CashbackModel"
import ClientDataService from "@/services/ClientDataService"
import MembershipService from "@/services/MembershipService"
import DisplayInformation from '@/components/DisplayInformation.vue'
import modalBasic from '@/components/Modal/Basic.vue'
import PaymentModel from "@/models/PaymentModel"
import { required } from 'vuelidate/lib/validators'

export default {
  name: "Customer",
  mixins: [helper],
  components:{
    modalBasic,
    DisplayInformation
  },
  data () {
    return {
      packageId: "",
      pkgCurrentStatus:{},
      modalActive: false,
      customer: new Customer(),
      profileImg: "",
      changePwdStatus: false,
      customerRate: 0,
      objChangePass: {
          valpwd: 0,
          email: '',
          newpassword: '',
          confirmPass: '',
      },
      packages: [],
      Roles:{},
      confirmStatus: false,
      cashbackData: [],
      isUpdating: false,
      ModalTitle: 'Agregar Cashback',
      ModalActive: false,
      stCashbackPending: 8,
      cashback: new CashbackModel(),
      cashbackIndex: 0,
      status: [],
      isFranquise: false,
      members: [],
      cashbacks: [],
      payment: new PaymentModel(),
      months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      popupActivo4: false,
      banks: [
          {
              value: "BAC USD",
              text: "BAC - Dolares"
          },
          {
              value: "BAC CRC",
              text: "BAC - Colones"
          }
      ]

    }
  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
  },
  created(){
    this.Roles = Role    
    this.$Progress.start();
    if(this.userInfoData.role != this.Roles.Admin){
        this.$router.push('/')
    }
    this.retrieveCustomer(this.$route.params.id)
    this.getFranchiseDetailAd(this.$route.params.id)
    this.$Progress.finish()
  },
  
    validations: {
        payment: 
            { 
                id: { required },
                bank: { required },
                txNumber: { required }
            },
    },
    methods: {
        notificationInfo(){
        let _info = "";
            if(this.customer.whatsapp == '1'){
                _info = "Whatsapp, ";
            }
            if(this.customer.bycall == '1'){
                _info += "Llamada, ";
            }
            if(this.customer.bymail == '1'){
                _info += "Correo";
            }
        return _info;
        },
        ...mapActions([
        'addUserInfo'
        ]),
        async getFranchiseDetailAd (id) {
            let response = await MembershipService.getFranchiseDetailAd({customerId: id})
            console.log(response)
            if((response.status / 100) == 2) {
                this.members = response.data.members
                this.cashbacks = response.data.cashbacks
            }
        },
        retrieveCustomer(id) {
            ClientDataService.getCustomerWithPacks(id)
            .then(response => {
                this.customer = response.data.customer;
                this.cashbackData = response.data.cashback
                this.objChangePass.email = this.customer.email
                this.packages = response.data.packages;
                this.customerRate = this.customer.rate;
                this.cashback.customer = id
                this.isFranquise = this.customer.typecode == '03' ? true : false
            })
            .catch(e => {
                console.log(e);
                if(e.response.status == 404){
                    this.$router.push({ name: "clients"})
                    this.$vs.notify({title:'Error!',text:'El cliente no fue encontrado.',color:'danger',icon:'error_outline'})
                }else{
                    this.$router.push({ name: "clients"})
                    this.$vs.notify({title:'Error!',text:'Error obteniendo los datos del cliente!',color:'danger',icon:'error_outline'})
                }
            });
        },
        openModal (_id) {
            this.payment = new PaymentModel();
            this.ModalActive = true
            this.payment.id  =  _id
            this.$v.$reset()
        },
        closeModal () {
            // this.ModalTitle  = 'Nuevo Impuesto'
            this.ModalActive = false
            this.payment = new PaymentModel();
            this.$v.$reset()
            this.$refs.file.value = null;
        },
        handleRequest(){
            const that = this
            console.log(this.tax);
            that.loadingProgress ('#btnConfirm')
            that.confirmStatus = true
            let formData = new FormData();
            formData.append('file', this.payment.file);
            formData.append('id', this.payment.id);
            formData.append('bank', this.payment.bank);
            formData.append('txNumber', this.payment.txNumber);

            MembershipService.cashbackPay(formData)
            .then(response => {
                that.confirmStatus = false
                console.log(response)
                that.$vs.loading.close('#btnConfirm .con-vs-loading')
                that.ModalActive = false
                that.$vs.notify({title:'Creado!',text:'El registro del pago fue aplicado exitosamente!',color:'success',icon:'check'})
                
                let obj = this.cashbacks.find( item => item.id == that.payment.id);
                    obj.st01Code = response.data.cashback.st01Code
                    obj.statusName = response.data.cashback.statusName

                that.payment = new PaymentModel()
                this.$v.$reset()
                this.$refs.file.value = null
            })
            .catch(e => {
                console.log(e)
                that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                that.confirmStatus = false
                that.$vs.notify({title:'Información!',text:'Error creando el pago',color:'danger',icon:'error_outline'})                
            });
        },
        handleFileUpload(){
            console.log(this.$refs.file.files[0]);
            this.payment.file = this.$refs.file.files[0];
        }
        
    }
}
</script>